export const biddingSummaryPrintPageStyles = `
  @page {
    margin: 16mm 14mm;
    size: auto;
  }
  @media print {
    *,
    *::before,
    *::after {
      box-shadow: none !important;
      text-shadow: none !important;
    }
    html,
    body {
      margin: 0 !important;
      padding: 0 !important;
      background: #fff !important;
      font-family: 'Roboto', 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
      font-size: 11pt !important;
      line-height: 1.38 !important;
      color: #111 !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
    body::before {
      content: none !important;
      display: none !important;
    }
    .bidding-summary-print-root .collapse,
    .bidding-summary-print-root .collapse:not(.show) {
      display: block !important;
      height: auto !important;
      max-height: none !important;
      overflow: visible !important;
      visibility: visible !important;
      opacity: 1 !important;
    }

    .bidding-summary-print-root [class*='accordion-section-toggle'] {
      background: #eaeaea !important;
      cursor: default !important;
      border: none !important;
      border-radius: 0 !important;
      padding: 0.4rem 0.55rem !important;
      margin: 0.75rem 0 0 !important;
      box-shadow: none !important;
      page-break-after: avoid;
      font-size: inherit !important;
      line-height: 1.35 !important;
    }
    .bidding-summary-print-root .summary-accordion-card:first-of-type [class*='accordion-section-toggle'] {
      margin-top: 0 !important;
    }
    .bidding-summary-print-root [class*='accordion-section-toggle'] > span.material-icons {
      display: none !important;
    }
    .bidding-summary-print-root .summary-stat-card img,
    .bidding-summary-print-root .summary-stat-card .material-icons.summary-stat-icon {
      display: none !important;
    }
    .bidding-summary-print-root .summary-accordion-head-icon,
    .bidding-summary-print-root [class*='accordion-section-toggle'] img {
      display: none !important;
    }
    .bidding-summary-print-root .summary-stat-svg-head {
      gap: 0 !important;
    }
    .bidding-summary-print-root .summary-stat-card.card {
      border: none !important;
      border-radius: 0 !important;
      box-shadow: none !important;
      background: transparent !important;
    }
    .bidding-summary-print-root .summary-accordion-card,
    .bidding-summary-print-root .summary-accordion-card.card.border {
      border: none !important;
      border-radius: 0 !important;
      box-shadow: none !important;
      page-break-inside: avoid;
      break-inside: avoid;
      margin-bottom: 0.75rem !important;
      background: transparent !important;
    }
    .bidding-summary-print-root .summary-stat-row {
      margin-bottom: 0.25rem !important;
    }
    .bidding-summary-print-root .summary-stat-card .card-body {
      padding: 0.55rem 0.65rem !important;
    }
    .bidding-summary-print-root .summary-accordion-body {
      padding: 0.5rem 0.15rem 0.75rem !important;
      background: transparent !important;
    }
    .bidding-summary-print-root .badge {
      border: 1px solid #bbb !important;
      font-weight: 500 !important;
    }
    .bidding-summary-print-root .badge-sessao-dias {
      display: none !important;
    }

    .bidding-summary-print-root .summary-print-cover {
      display: flex !important;
      flex-direction: column !important;
      align-items: flex-start !important;
      gap: 8pt !important;
      padding-bottom: 14pt;
      margin-bottom: 14pt !important;
      border-bottom: 2px solid #000 !important;
      position: relative !important;
      min-height: unset !important;
    }
    .bidding-summary-print-root .summary-print-cover-logo {
      position: static !important;
      width: 48mm !important;
      max-width: none !important;
      max-height: 20mm !important;
      height: auto !important;
      object-fit: contain !important;
      object-position: left top !important;
      display: block !important;
      flex-shrink: 0 !important;
    }
    .bidding-summary-print-root .summary-print-cover-text {
      width: 100% !important;
      max-width: 100% !important;
      text-align: left !important;
      box-sizing: border-box !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
    .bidding-summary-print-root .summary-print-cover-title {
      font-size: 16pt;
      font-weight: 700;
      margin-bottom: 4pt !important;
      letter-spacing: -0.02em;
      color: #000 !important;
    }
    .bidding-summary-print-root .summary-print-cover-meta {
      font-size: 9.5pt;
      margin-bottom: 0 !important;
      color: #444 !important;
    }
    .bidding-summary-print-root .summary-print-cover-date {
      font-size: 9pt;
      margin-top: 8pt !important;
      color: #555 !important;
    }
  }
`;
